import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import { formatPrice, priceToInt, getFormattedValue } from '../../helpers/price';

const InputCurrency = ({ id, name, type, value, onChange, placeholder, disabled }) => (
  <Input
    id={id}
    name={name}
    type={type}
    value={formatPrice(priceToInt(value) / 100)}
    onChange={e => onChange(e, getFormattedValue(e))}
    placeholder={placeholder}
    disabled={disabled}
  />
);

InputCurrency.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

InputCurrency.defaultProps = {
  type: 'text',
  value: '',
  placeholder: 'R$',
};

export default InputCurrency;



// WEBPACK FOOTER //
// ./src/components/InputCurrency/index.js